module.exports = __webpack_public_path__ + "src/img/artist/work01_3.jpg?e5e36d9d62033eab955740ff28fb3643";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/work01_3.jpg
// module id = 148
// module chunks = 0